import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import HotelInvoiceForm from "./components/HotelInvoiceForm";
import RoundTripForm from "./components/RoundTripForm";
import ItineraryForm from "./components/ItineraryForm";
import OneWayForm from "./components/OneWayForm";
import Hotel from "./components/Hotels";
import UserManagement from "./components/UserManagement";
import Location from "./components/Location";
import LocationDetails from "./components/LocationDetails";


function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [submittedForms, setSubmittedForms] = useState([]);

  useEffect(() => {
    const loggedIn = localStorage.getItem("isLoggedIn");
    if (loggedIn === "true") {
      setIsLoggedIn(true);
    }
  }, []);

  const handleLogin = () => setIsLoggedIn(true);
  const handleLogout = () => {
    localStorage.removeItem("isLoggedIn");
    setIsLoggedIn(false);
  };

  // ✅ This will be called from forms
  const handleFormSubmit = (formData) => {
    setSubmittedForms((prev) => [...prev, formData]);
  };

  return (
    <Router>
      <Routes>
        {!isLoggedIn ? (
          <Route path="*" element={<Login onLogin={handleLogin} />} />
        ) : (
          <>
            <Route
              path="/"
              element={<Dashboard onLogout={handleLogout} forms={submittedForms} />}
            />

            <Route path="/one-way" element={<OneWayForm onSubmit={handleFormSubmit} />} />
            <Route path="/round-trip" element={<RoundTripForm onSubmit={handleFormSubmit} />} />
            <Route path="/hotel-invoice" element={<HotelInvoiceForm onSubmit={handleFormSubmit} />} />
            <Route path="/itinerary" element={<ItineraryForm onSubmit={handleFormSubmit} />} />
            <Route path="/hotel" element={<Hotel onSubmit={handleFormSubmit} />} />
            <Route path="/users" element={<UserManagement onSubmit={handleFormSubmit} />} />
            <Route path="/locations" element={<Location />} />
            <Route  path="/locations/:id" element={<LocationDetails />} />
          </>
        )}
      </Routes>
    </Router>
  );
}


export default App;
